import http from 'utils/http'

const companiesToUser = payload => http.post('/user/v1/business/search', payload)

const validateMobile = payload => http.post('/user/v1/sign-up/validate-mobile', payload)

const sendDetails = payload => http.post('/user/v1/sign-up/send-details', payload)

const createNewUserByEmail = userEmail => http.post('/user/v1/sign-up', [{ userEmail }])

const sendDetailsWithCodeMobile = payload => http.post('/user/v1/sign-up/with-code-mobile', payload)

export default {
  companiesToUser,
  validateMobile,
  sendDetails,
  sendDetailsWithCodeMobile,
  createNewUserByEmail,
}



// WEBPACK FOOTER //
// ./src/services/signUpService.js